import * as React from 'react';


import {
    UpcomingAppointmentsModel,
} from './model';


import {
    buildGearActionsMenu,
} from 'one-ui-gear/src/actions';

import {
    UpcomingAppointmentsCardProps,
} from './props';

import {
    CardLight,
} from 'one-ui-card/src/card-light';
import {
    checkCardHasError,
    CardErrorMsg,
    CardLockIcon
} from 'one-card-notification';

import Skeleton from 'antd/lib/skeleton';
import {
    CardNoData
} from 'one-ui-card';
import { useCtx } from "one-ui-provider";

/**
 * This function returns the upcomming appointments
 * @param props has all input parameters to load the Card
 * @returns JSX code for Upcoming Appointment Card
 */
export const UpcomingAppointmentCard = <M extends UpcomingAppointmentsModel>(
    props: UpcomingAppointmentsCardProps<M>
) => {
    const {
        model,
        title,
        gearActions = [],
        skeleton,
        //graph = true
    } = props;

    const {
        totalupcomingappointments,
        totalcancelappointments,
        totalnoshow,
        // chartdata,
        // colorscheme = defaultColorSchema,
        // note
    } = model || {};

    const {
        upcomingAppts_skeleton,
    } = skeleton;
    const { settings } = useCtx();
    const { uisettings: { dashboardcardconfig } } = settings;
    // Initial
    let result = (
        <div className="line-description">
            <div className="line-description__item">
                <div className="line-description__item-title">Upcoming</div>
                <div className="line-description__item-note">{totalupcomingappointments}</div>
            </div>
            <div className="line-description__item">
                <div className="line-description__item-title">Canceled</div>
                <div className="line-description__item-note">{totalcancelappointments}</div>
            </div>
            <div className="line-description__item">
                <div className="line-description__item-title">No Show</div>
                <div className="line-description__item-note">{totalnoshow}</div>
            </div>
        </div>
    );

    if((totalupcomingappointments === 0) &&
       (totalcancelappointments === 0) &&
       (totalnoshow === 0)){
        result = 
        <>
            <CardNoData/>
        </>
    }

    if(checkCardHasError('Appointments') &&
        (totalupcomingappointments === 0) &&
        (totalcancelappointments === 0) &&
        (totalnoshow === 0)){
        result = 
        <>
            <CardErrorMsg />
        </>
    }

    // If upcoming appts skeleton is true
    if (upcomingAppts_skeleton) {
        result = (<Skeleton active paragraph={{ rows: 1 }} />);
    }

    // Based on Appointment flag If Appointment flag set as false then Lock Icon Will Show
    if (!dashboardcardconfig?.appointments){
        result = 
        <>
            <CardLockIcon />
        </>
        return (
            <CardLight
                title={title}
    
                body={
                    result
                }
            />
        );
    }
    else {
        return (
            <CardLight
                title={title}
                gearActions={
                    buildGearActionsMenu(
                        gearActions,
                    )
                }
                body={
                    result
                }
            />
        );
    }
};
